import { render, staticRenderFns } from "./NewDependencyForm.vue?vue&type=template&id=71788084&scoped=true&"
import script from "./NewDependencyForm.vue?vue&type=script&lang=js&"
export * from "./NewDependencyForm.vue?vue&type=script&lang=js&"
import style0 from "./NewDependencyForm.vue?vue&type=style&index=0&id=71788084&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71788084",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71788084')) {
      api.createRecord('71788084', component.options)
    } else {
      api.reload('71788084', component.options)
    }
    module.hot.accept("./NewDependencyForm.vue?vue&type=template&id=71788084&scoped=true&", function () {
      api.rerender('71788084', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/taskSettings/sections/dependencies/includes/NewDependencyForm.vue"
export default component.exports